import { FlagType, IApplicationResult, RecommendationCriticity } from '../types';
import { NorthStarPath } from '../types/north-star-target.type';
import { isNumber } from '../utils';

export const flagLabels: { [key: string]: string } = {
  danger: 'To improve',
  warning: 'Medium',
  success: 'Good',
  light: 'Not applicable',
  secondary: '-',
};

export const getFlagLabel = (flag?: string): string | undefined => {
  return flag ? flagLabels[flag] : flag;
};

export const getFlag = (value: IApplicationResult['value'] | undefined | boolean | null): FlagType => {
  switch (value) {
    case 'bad':
      return 'danger';
    case 'good':
    case 'intermediate':
      return 'success';
    case 'medium':
      return 'warning';
    default:
      return 'transparent';
  }
};

export const getValueFlag = (value: IApplicationResult['value'] | undefined): FlagType => {
  if (isNumber(String(value))) {
    return 'transparent';
  }

  switch (value) {
    case 'good':
    case NorthStarPath.ALREADY_AZURE:
      return 'success';
    case 'bad':
      return 'danger';
    case 'n/a':
      return 'light';
    case 'n/d':
    case 'No data':
      return 'secondary';
    case undefined:
      return 'secondary';

    default:
      return 'black';
  }
};

export const getRuleFlag = (result: IApplicationResult['value'] | undefined | boolean | null): FlagType => {
  switch (result) {
    case 'good':
      return 'success';
    case 'medium':
      return 'warning';
    case 'bad':
      return 'danger';
    case 'n/a':
      return 'light';
    case 'n/u':
      return 'secondary';
    case 'n/d':
    case 'intermediate':
      return 'secondary';
    case '1':
      return 'success';
    case '0':
      return 'danger';
    case undefined:
      return 'secondary';
    default:
      return 'transparent';
  }
};

export const getSGMarketsFlag = (result: IApplicationResult['value'] | undefined | boolean): FlagType => {
  switch (result) {
    case 'good':
      return 'success';
    case 'bad':
      return 'danger';
    case undefined:
      return 'secondary';
    case 'n/a':
      return 'light';
    case 'n/d':
      return 'secondary';
    default:
      return 'light';
  }
};

export const getRuleText = (result: IApplicationResult['value']): string => {
  switch (result) {
    case 'good':
      return 'Good';
    case 'bad':
      return 'To improve';
    case 'n/a':
      return 'Not applicable';
    case 'n/d':
      return 'No data';
    case 'n/u':
      return 'Not used';
    case 'medium':
      return 'Medium';

    default:
      return result;
  }
};

export const getFlagByCriticity = (criticity: RecommendationCriticity | undefined) => {
  if (criticity === undefined) return;
  switch (criticity) {
    case 'low':
      return 'info';
    case 'medium':
      return 'warning';
    default:
      return 'danger';
  }
};

export const getBadgeFlagByCriticity = (criticity: RecommendationCriticity | undefined) => {
  switch (criticity) {
    case 'low':
      return 'badge-discreet-info';
    case 'medium':
      return 'badge-discreet-warning';
    case 'high':
      return 'badge-discreet-danger';
    case 'very-high':
      return 'badge-danger';
    default:
      return 'badge-discreet-dark';
  }
};

export const novaBadgeColor = (platformizationNovaKey: string | undefined) => {
  switch (platformizationNovaKey) {
    case 'yes':
      return 'success';
    case 'n/a':
      return 'dark';
    case 'no':
    case 'to be completed':
      return 'danger';
    default:
      return 'secondary';
  }
};

export const getRuleValueToResultKey = (ruleValue: string): string => {
  switch (ruleValue) {
    case 'Good':
      return 'good';
    case 'To improve':
      return 'bad';
    case 'Not applicable':
      return 'n/a';
    case 'No data':
      return 'n/d';
    case 'Medium':
      return 'medium';
    default:
      return 'No data';
  }
};

export const northStarBadgeColor = (status: NorthStarPath | undefined) => {
  switch (status) {
    case NorthStarPath.ALREADY_AZURE:
      return 'success';
    case NorthStarPath.NO_DATA:
      return 'secondary';
    case NorthStarPath.NOT_APPLICABLE:
      return 'dark';
    default:
      return 'dark';
  }
};

export const northStarLabel = (status: NorthStarPath | string | null | undefined) => {
  switch (status) {
    case NorthStarPath.NOT_APPLICABLE:
      return 'Not applicable';
    case NorthStarPath.ALREADY_AZURE:
      return 'Already on Azure';
    case NorthStarPath.WILL_NOT_GO_AZURE:
      return 'Will not go to Azure';
    case undefined:
    case null:
      return NorthStarPath.NO_DATA;
    default:
      return status;
  }
};
